import { useRoutes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

export default function ThemeRoutes() {
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);

  const routes = isLoggedIn
    ? [
        MainRoutes,
        AuthenticationRoutes,
        {
          path: '*',
          element: <Navigate to="/tenants" replace />
        }
      ]
    : [
        AuthenticationRoutes,
        {
          path: '*',
          element: <Navigate to="/login" replace />
        }
      ];

  return useRoutes(routes);
}
